var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSummaryAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 468 468",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,234,234)",
    id: "\\u6A21\\u7CCA\\u677F\\u539F"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "\\u25A8 \\u6A21\\u7CCA\\u677F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    id: "ch_ bg.png"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "6.666666666666667s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 1; 1; 0",
    keyTimes: "0; 0.25; 0.85; 1",
    keySplines: "0.333 0 0.667 1; 0.167 0 0.833 1; 0.167 0 0.833 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "6.667s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 360; 720",
    keyTimes: "0; 0.605; 1",
    keySplines: "0.609 0 0 1; 0.556 0 0.385 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-234,-234)"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)",
    id: "\\u906E\\u76D6.png"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,234,234)",
    id: "\\u6A21\\u7CCA\\u677F\\u539F"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,234,234)",
    id: "\\u6A21\\u7CCA\\u677F-\\u51CF\\u914D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6A21\\u7CCA\\u677F",
    transform: "matrix(3,0,0,3,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 4,
    rx: 4,
    height: 0,
    width: 0,
    y: 0,
    x: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeWidth: 1,
    strokeOpacity: 1,
    stroke: "#ffffff",
    fill: "#ffffff",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "stroke-opacity",
    dur: "4.633333333333334s",
    begin: "2.033333333333333s",
    calcMode: "spline",
    values: "1; 0.58549; 0.1; 0.1; 1",
    keyTimes: "0; 0.065; 0.137; 0.784; 1",
    keySplines: "0.333 0 0.667 0.487; 0.333 0.486 0.667 1; 0.333 0 0.152 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "width",
    dur: "6.333333333333333s",
    begin: "0.3333333333333333s",
    calcMode: "spline",
    values: "0; 60; 60; 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.79 0 0.021 1; 0.167 0 0 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "height",
    dur: "6.333333333333333s",
    begin: "0.3333333333333333s",
    calcMode: "spline",
    values: "0; 60; 60; 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.79 0 0.021 1; 0.167 0 0 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "rx",
    dur: "5.666666666666667s",
    begin: "1s",
    calcMode: "spline",
    values: "4; 8; 8; 4",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0.986 0 0 1; 0.333 0 0 1; 1 0 0.005 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "ry",
    dur: "5.666666666666667s",
    begin: "1s",
    calcMode: "spline",
    values: "4; 8; 8; 4",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0.986 0 0 1; 0.333 0 0 1; 1 0 0.005 1",
    fill: "freeze"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "Star 1.png"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0.333s",
    calcMode: "discrete",
    fill: "freeze",
    dur: "20s",
    values: "visible; visible",
    keyTimes: "0; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5.666666666666667s",
    begin: "1s",
    calcMode: "spline",
    values: "0; 1; 1; 0",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(223.679,233.728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.667s",
    begin: "1s",
    calcMode: "spline",
    values: "0 0; 1.6 1.6; 1.6 1.6; 0 0",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0.802 0 0 1; 0 0 1 1; 0.991 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21,-25.5)"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "Star 2.png"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0.333s",
    calcMode: "discrete",
    fill: "freeze",
    dur: "19.667s",
    values: "visible; visible",
    keyTimes: "0; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5.666666666666667s",
    begin: "1s",
    calcMode: "spline",
    values: "0; 1; 1; 1; 0",
    keyTimes: "0; 0.294; 0.529; 0.824; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.364,203.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "3s",
    begin: "2.667s",
    calcMode: "spline",
    values: "0; 180; 180; 360",
    keyTimes: "0; 0.444; 0.556; 1",
    keySplines: "1 0 0.491 1; 0.98 0 0.491 1; 0.98 0 0.494 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.667s",
    begin: "1s",
    calcMode: "spline",
    values: "0 0; 1.2 1.2; 1.2 1.2; 0 0",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0.809 0 0 1; 0 0 1 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12,-13.5)"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0,
    visibility: "hidden",
    id: "Star 3.png"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0.333s",
    calcMode: "discrete",
    fill: "freeze",
    dur: "19.667s",
    values: "visible; visible",
    keyTimes: "0; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "opacity",
    dur: "5.666666666666667s",
    begin: "1.0333333333333334s",
    calcMode: "spline",
    values: "0; 1; 1; 0",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0 0 1 1; 0 0 1 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.371,259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.667s",
    begin: "1.033s",
    calcMode: "spline",
    values: "0 0; 1.4 1.4; 1.4 1.4; 0 0",
    keyTimes: "0; 0.294; 0.824; 1",
    keySplines: "0.802 0 0 1; 0 0 1 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.5,-6)"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\u53F3\\u4E0B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.333s",
    begin: "0.333s",
    calcMode: "spline",
    values: "0 0; 2.3 2.3; 2.3 2.3; 0 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.794 0 0.016 1; 0 0 1 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62 1"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10,
    rx: 10,
    height: 78,
    width: 78,
    y: 0,
    x: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-39L29,-39C34.523,-39,39,-34.523,39,-29L39,29C39,34.523,34.523,39,29,39L-29,39C-34.523,39,-39,34.523,-39,29L-39,-29C-39,-34.523,-34.523,-39,-29,-39L0,-39Z",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }))))))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE6\\u4E0B"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.333s",
    begin: "0.333s",
    calcMode: "spline",
    values: "0 0; 2.3 2.3; 2.3 2.3; 0 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.794 0 0.016 1; 0 0 1 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62 1"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10,
    rx: 10,
    height: 78,
    width: 78,
    y: 0,
    x: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-39L29,-39C34.523,-39,39,-34.523,39,-29L39,29C39,34.523,34.523,39,29,39L-29,39C-34.523,39,-39,34.523,-39,29L-39,-29C-39,-34.523,-34.523,-39,-29,-39L0,-39Z",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }))))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "\\u5DE6\\u4E0A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.333s",
    begin: "0.333s",
    calcMode: "spline",
    values: "0 0; 2.3 2.3; 2.3 2.3; 0 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.794 0 0.016 1; 0 0 1 1; 1 0 0 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62 1"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10,
    rx: 10,
    height: 78,
    width: 78,
    y: 0,
    x: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-39L29,-39C34.523,-39,39,-34.523,39,-29L39,29C39,34.523,34.523,39,29,39L-29,39C-34.523,39,-39,34.523,-39,29L-39,-29C-39,-34.523,-34.523,-39,-29,-39L0,-39Z",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 4,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\u53F3\\u4E0A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234,234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "6.333s",
    begin: "0.333s",
    calcMode: "spline",
    values: "0 0; 2.3 2.3; 2.3 2.3; 0 0",
    keyTimes: "0; 0.368; 0.842; 1",
    keySplines: "0.794 0 0.016 1; 0 0 1 1; 1 0 0.019 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62 1"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 10,
    rx: 10,
    height: 78,
    width: 78,
    y: 0,
    x: 0,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 0,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "stroke-width",
    dur: "5.166666666666667s",
    begin: "1.5s",
    calcMode: "spline",
    values: "0; 4; 4; 0",
    keyTimes: "0; 0.226; 0.806; 1",
    keySplines: "0.981 0 0 1; 0.167 0 0 1; 1 0 0 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,-39L29,-39C34.523,-39,39,-34.523,39,-29L39,29C39,34.523,34.523,39,29,39L-29,39C-34.523,39,-39,34.523,-39,29L-39,-29C-39,-34.523,-34.523,-39,-29,-39L0,-39Z",
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeWidth: 0,
    strokeOpacity: 1,
    stroke: "#ffffff"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "stroke-width",
    dur: "5.166666666666667s",
    begin: "1.5s",
    calcMode: "spline",
    values: "0; 4; 4; 0",
    keyTimes: "0; 0.226; 0.806; 1",
    keySplines: "0.981 0 0 1; 0.167 0 0 1; 1 0 0 1",
    fill: "freeze"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryAnimation);
export default __webpack_public_path__ + "static/media/summary-animation.0ede0c87923d4fcd2f430b97d28f1cb2.svg";
export { ForwardRef as ReactComponent };